var map = {
	"./boletincasa.jpg": "8893",
	"./boletindelitos.jpg": "1968",
	"./boletines.jpg": "fc44",
	"./covid.jpg": "1450",
	"./expulsados.jpg": "e49b",
	"./prision_preventiva.png": "81e6",
	"./sanciones.jpg": "10f9",
	"./sentencias.jpg": "49f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6a0";